import axios from "axios";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const getDeviceId = () => {
  let id = localStorage.getItem("hd_device_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("hd_device_id", id);
  }
  return id;
};

export const nowIstanbulHour = () => {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Istanbul", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23" })
      .formatToParts(new Date()).map((x) => [x.type, x.value])
  );
  return `${p.year}-${p.month}-${p.day}T${p.hour}:00`;
};

export const distKm = (a, b) => {
  const R = 6371, toR = Math.PI / 180;
  const dLat = (b.lat - a.lat) * toR, dLon = (b.lon - a.lon) * toR;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
};

export const errMsg = (e, fallback) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fallback);
